function getWebApp() {
    return window.Telegram?.WebApp || null;
}

export async function init() {
    const webApp = getWebApp();
    if (!webApp?.initData) throw new Error('Telegram Mini App is not available');
    return webApp;
}

const impactOccurred = style => {
    const feedback = getWebApp()?.HapticFeedback;
    if (feedback && typeof feedback.impactOccurred === 'function') {
        feedback.impactOccurred(style);
    }
};
impactOccurred.isAvailable = () => Boolean(
    getWebApp()?.initData &&
    typeof getWebApp()?.HapticFeedback?.impactOccurred === 'function'
);

export const hapticFeedback = {
    isAvailable: () => impactOccurred.isAvailable(),
    impactOccurred
};

const ready = async () => {
    getWebApp()?.ready?.();
};
ready.isAvailable = () => Boolean(getWebApp()?.initData && typeof getWebApp()?.ready === 'function');

export const miniApp = { ready };

let activeBackHandler = null;
export const backButton = {
    mount() {},
    show() {
        getWebApp()?.BackButton?.show?.();
    },
    hide() {
        getWebApp()?.BackButton?.hide?.();
    },
    onClick(handler) {
        const nativeBackButton = getWebApp()?.BackButton;
        if (!nativeBackButton || typeof handler !== 'function') return;
        if (activeBackHandler && typeof nativeBackButton.offClick === 'function') {
            nativeBackButton.offClick(activeBackHandler);
        }
        activeBackHandler = handler;
        nativeBackButton.onClick?.(handler);
    }
};

export function openTelegramLink(url) {
    const webApp = getWebApp();
    if (!webApp?.initData) return false;
    if (typeof webApp.openTelegramLink === 'function') {
        webApp.openTelegramLink(url);
        return true;
    }
    if (typeof webApp.openLink === 'function') {
        webApp.openLink(url);
        return true;
    }
    return false;
}
